import React,{useState,useEffect} from 'react';
import LeadershipItem from "../../../Items/LeadershipItem"

import { postData } from '../../../../services/api';
import { useTranslation } from "react-i18next";

const LeadershipSection = ({title,description}) => {
  const { i18n } = useTranslation();
  const [planData, setPlanData] = useState([]);

  useEffect(() => {
    const loadList = async () => {
      const result = await postData("/leadership/list", {
        sortQuery: {"created_at":1}
      });
      if (result.data) {
        setPlanData(
          result.data.map((item,index)=>{
            return {
              image:item?.image,
              title:item?.name?.[i18n?.language],
              description:"<p>"+item?.description?.[i18n?.language]+"</p>"
            }
          })
        );
      }
    };
    loadList();
  }, [i18n?.language]);
  const LeadershipData = {
    title:title,  
    description:description,
    Leadership:planData
  }
  return (
    <section className="relative w-full py-10 bg-white" id="leadership-section">
      <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl  mx-auto">
        
          <div className="max-w-3xl w-full mx-auto text-center mb-10 xl:mb-20 space-y-3 lg:space-y-10 xl:space-y-16">
                <h2 className="capitalize text-slate-950  !leading-tight text-2xl xs:text-3xl lg:text-5xl xl:text-6xl  font-extrabold font-PlusJakartaSans" dangerouslySetInnerHTML={{__html:LeadershipData.title}}></h2>
                <div className="text-sm lg:text-base text-slate-700" dangerouslySetInnerHTML={{__html:LeadershipData.description}}></div>
          </div>
          <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-5 lg:gap-y-10 xl:gap-y-14 2xl:gap-y-16">
                  {LeadershipData.Leadership.map((item, index) => (
                      <LeadershipItem key={index} data={item}/>
                  ))}
          </div>
      </div>
  </section>
  );
};

export default LeadershipSection;